import * as React from "react";
import type { SVGProps } from "react";
const SvgAddSquare02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="M15.6 12H12m0 0H8.4m3.6 0v3.6m0-3.6V8.4m9.6 3.6a9.6 9.6 0 1 1-19.2 0 9.6 9.6 0 1 1 19.2 0Z"
      opacity={0.9}
    />
  </svg>
);
export default SvgAddSquare02;
